import qs from "qs";
import request from "@/utils/request";

// 注册会员
export async function insertVip(params = {}) {
  return request.post("nxin.qd.manage.wx.mini.register.member/1.0", qs.stringify(params));
}

// 查询门店
export async function getShop(params = {}) {
  return request.get("nxin.qd.system.shop.get/1.0", {
    params
  });
}

// 获取验证码
export async function getSms(params = {}) {
  return request.post("nxin.qd.manage.wx.mini.register.send.short.message/1.0", qs.stringify(params));
}
